import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import AirportPickupPeriodicHikeDayDrawer from "components/drawer/AirportPickupPeriodicHikeDayDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import dayjs from "dayjs";

const AirportPickupPeriodicHikeDayTable = ({
  airportPickupPeriodicHikeDay,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const airportPickupPeriodicHikeDaysorted = airportPickupPeriodicHikeDay.sort(
    (a, b) => a.city_names.localeCompare(b.city_names)
  );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <AirportPickupPeriodicHikeDayDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {airportPickupPeriodicHikeDaysorted
          ?.slice(0, perpage)
          .map((data, index) => (
            <React.Fragment key={data.id}>
              {data["vehicle_type_id"].map((item, vehicleIndex) => (
                <TableRow key={`${data.id}-${vehicleIndex}`}>
                  {/* Display Sl.No., Airport, Start Date, and End Date only on the first row of each vehicle type group */}
                  {vehicleIndex === 0 && (
                    <>
                      <TableCell
                        className="text-xs text-center"
                        rowSpan={data["vehicle_type_id"].length}
                      >
                        {(currentPage - 1) * perpage + index + 1}
                      </TableCell>
                      <TableCell
                        rowSpan={data["vehicle_type_id"].length}
                        className="text-xs text-center"
                      >
                        {data["city_names"]}
                      </TableCell>
                      <TableCell
                        className="text-xs text-center"
                        rowSpan={data["vehicle_type_id"].length}
                      >
                        {dayjs(data["start_date"]).format("DD-MM-YYYY")}
                      </TableCell>
                      <TableCell
                        className="text-xs text-center"
                        rowSpan={data["vehicle_type_id"].length}
                      >
                        {dayjs(data["end_date"]).format("DD-MM-YYYY")}
                      </TableCell>
                    </>
                  )}

                  {/* Render each vehicle type and hike percentage in individual rows */}
                  <TableCell className="text-xs text-center">
                    {data["vehicle_type_names"][item]}
                  </TableCell>
                  <TableCell className="text-xs text-center">
                    {data["hike"][item] + "%"}
                  </TableCell>

                  {/* Display Actions only on the first row of each grouped vehicle type */}
                  {vehicleIndex === 0 && (
                    <TableCell
                      rowSpan={data["vehicle_type_id"].length}
                      className="text-center"
                    >
                      <EditDeleteButton
                        title={data["Airport Pickup"]}
                        id={data.id}
                        handleUpdate={handleUpdate}
                        handleModalOpen={handleModalOpen}
                        hideDelete={hideDelete}
                        hideEdit={hideEdit}
                      />
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
      </TableBody>
    </>
  );
};

export default AirportPickupPeriodicHikeDayTable;
